'use strict';

// core version + modules:
import Swiper, { Navigation } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

const SliderHeader = {
    els: null,
    swiper: null,
    headerDescription: null,
    init: function () {
        SliderHeader.els = document.querySelectorAll('.header__slider');
        if (SliderHeader.els && SliderHeader.els.length > 0) {
            SliderHeader.els.forEach(el => {
                SliderHeader.create(el);
                if (SliderHeader.swiper && SliderHeader.headerDescription && SliderHeader.swiper.slides[SliderHeader.swiper.realIndex].getAttribute('data-description')) {
                    SliderHeader.headerDescription.innerHTML = SliderHeader.swiper.slides[SliderHeader.swiper.realIndex].getAttribute('data-description')
                }
            });
        }
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');
        SliderHeader.headerDescription = el.querySelector('.js-slide-description')
        SliderHeader.swiper = new Swiper(slider, {
            modules: [Navigation],
            spaceBetween: 0,
            slidesPerView: 1,
            loop: false,
            speed: 600,
            autoHeight: false,
            navigation: {
                prevEl: ".header__slider__navigation-prev",
                nextEl: ".header__slider__navigation-next",
            },
            on: {
                slideChange: function () {
                    if (SliderHeader.swiper && SliderHeader.headerDescription && SliderHeader.swiper.slides[SliderHeader.swiper.realIndex].getAttribute('data-description')) {
                        SliderHeader.headerDescription.innerHTML = SliderHeader.swiper.slides[SliderHeader.swiper.realIndex].getAttribute('data-description')
                    }
                }
            }
        });
        // REMOVE ARROW IF ONLY 1 SLIDE 
        let slides = slider.querySelectorAll('.swiper-slide')
        if (slides.length <= 1) {
            document.querySelector('.header__slider__navigation-prev').style.display = 'none';
            document.querySelector('.header__slider__navigation-next').style.display = 'none';
        }
    },
};

export default SliderHeader;